import React from 'react';
import useCurrentUserHasAccessToArea from '../../../hooks/shared/useCurrentUserHasAccessToArea';
import type { AreasEnum } from '../../../enums/shared/AreasEnum';
import useAreaContext from '../../../hooks/contexts/useAreaContext';

const ButtonDisabledWithInsufficientPermission = (Button) => {
  return function GetButtonDisabledWithInsufficientPermission(props) {
    const areaContext: AreasEnum = useAreaContext();
    const userPermissions = useCurrentUserHasAccessToArea(areaContext);

    const { disabled } = props;
    const isDisabled = (disabled ?? false) || !userPermissions.canEdit;

    return <Button {...props} disabled={isDisabled} />;
  };
};

export default ButtonDisabledWithInsufficientPermission;
